<template>
  <div class="filter" :class="actionInputStyles">
    <div class="filter-inputs">
    <multiselect-dropdown
        ref="dropdownComponent1"
        :options="actionTypes"
        :selected-item="actionName"
        :has-thumbnail="false"
        :action-name="true"
        :show-action-input="showActionInput"
        :close="closeDropdown1"
        @click="onActionSelect"
        @close="onChangeStatus1"
      />
<!--      <select
        v-model="action_name"
        class="action__question"
        :class="{ 'full-width': !showActionInput }"
        :disabled="!hasPermission"
        @change="resetAction()"
      >
        <option
          v-for="attribute in actionTypes"
          :key="attribute.key"
          :value="attribute.key"
        >
          {{ attribute.label }}
        </option>
      </select>-->
      <div v-if="showActionInput" class="filter__answer--wrap">
        <div v-if="inputType">
          <div
            v-if="inputType === 'search_select'"
            class="multiselect-wrap--small"
          >
            <multiselect-dropdown
              ref="dropdownComponent2"
              :options="dropdownValues"
              :selected-item="actionParams"
              :has-thumbnail="false"
              :action-param="true"
              :close="closeDropdown2"
              @click="onParamSelect"
              @close="onChangeStatus2"
            />
<!--            <multiselect
              v-model="action_params"
              track-by="id"
              label="name"
              :placeholder="$t('FORMS.MULTISELECT.SELECT')"
              selected-label
              deselect-label=""
              :max-height="160"
              :options="dropdownValues"
              :allow-empty="false"
              :show-labels="false"
              :option-height="104"
              :class="{ 'disabled-multiselect': !hasPermission }"
            />-->
          </div>
          <div
            v-else-if="inputType === 'multi_select'"
            class="multiselect-wrap--small"
          >
            <multiselect
              ref="myMultiselect"
              v-model="action_params"
              track-by="id"
              label="name"
              :placeholder="$t('FORMS.MULTISELECT.SELECT')"
              :multiple="true"
              selected-label
              :allow-empty="false"
              deselect-label=""
              :max-height="160"
              :options="dropdownValues"
              :show-labels="false"
              :option-height="104"
              :class="{ 'disabled-multiselect': !hasPermission }"
              @open="handleOpen"
            />
          </div>
          <input
            v-else-if="inputType === 'email'"
            v-model="action_params"
            type="email"
            class="answer--text-input"
            :placeholder="$t('AUTOMATION.ACTION.EMAIL_PLACEHOLDER')"
            :readonly="!hasPermission"
          />
          <input
            v-else-if="inputType === 'url'"
            v-model="action_params"
            type="url"
            class="answer--text-input"
            :readonly="!hasPermission"
            placeholder="Enter url"
          />
          <automation-action-file-input
            v-if="inputType === 'attachment'"
            v-model="action_params"
            :has-permission="hasPermission"
            :initial-file-name="initialFileName"
          />
        </div>
      </div>
      <woot-button
        v-if="!isMacro"
        icon="dismiss"
        variant="clear"
        color-scheme="secondary"
        @click="removeAction"
      />
    </div>
    <automation-action-team-message-input
      v-if="inputType === 'team_message'"
      v-model="action_params"
      :has-permission="hasPermission"
      :teams="dropdownValues"
      :index="index"
      @multiOpen="onCloseDropdown"
      @multiSelectOpen="onMultiOpen(index)"
    />
    <woot-message-editor
      v-if="inputType === 'textarea'"
      v-model="castMessageVmodel"
      :has-permission="hasPermission"
      rows="4"
      :enable-variables="true"
      :placeholder="$t('AUTOMATION.ACTION.TEAM_MESSAGE_INPUT_PLACEHOLDER')"
      class="action-message"
    />
    <p
      v-if="v.action_params.$dirty && v.action_params.$error"
      class="filter-error"
    >
      {{ $t('FILTER.EMPTY_VALUE_ERROR') }}
    </p>
  </div>
</template>

<script>
import AutomationActionTeamMessageInput from './AutomationActionTeamMessageInput.vue';
import AutomationActionFileInput from './AutomationFileInput.vue';
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor';
import MultiselectDropdown from 'shared/components/ui/MultiselectDropdown.vue'  ;
export default {
  components: {
    AutomationActionTeamMessageInput,
    AutomationActionFileInput,
    WootMessageEditor,
    MultiselectDropdown,
  },
  data() {
    return {
      close1: false,
      close2: false,
    }
  },
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    actionTypes: {
      type: Array,
      default: () => [],
    },
    dropdownValues: {
      type: Array,
      default: () => [],
    },
    v: {
      type: Object,
      default: () => null,
    },
    showActionInput: {
      type: Boolean,
      default: true,
    },
    initialFileName: {
      type: String,
      default: '',
    },
    isMacro: {
      type: Boolean,
      default: false,
    },
    hasPermission: {
      type: Boolean,
      default: true,
    } ,
    index: {
      type: Number,
      required: true,
    }
  },
  mounted() {
    document.addEventListener('mousedown', this.handleClickOutside1);
    document.addEventListener('mousedown', this.handleClickOutside2);
    document.addEventListener('mousedown', this.handleClickOutside3);
    bus.$on('multiselect-open', (source) => {
      if (source !== 'myMultiselect') {
        this.onCloseDropdown3();
      }
    });
    bus.$on('multi-open', (sourceIndex) => {
      if (sourceIndex !== this.index) {
        this.onCloseDropdown3();
      }
    });
  },
  beforeDestroy() {
    bus.$off('multiselect-open');
    bus.$off('multi-open');
  },
  computed: {
    action_name: {
      get() {
        if (!this.value) return null;
        return this.value.action_name;
      },
      set(value) {
        const payload = this.value || {};
        this.$emit('input', { ...payload, action_name: value });
      },
    },
    actionName() {
      if (!this.value) {
        return null;
      }
      else {
        let matchingAttribute = this.actionTypes.find(attr => attr.key === this.value.action_name) ;
        return matchingAttribute;
      }
    },
    action_params: {
      get() {
        if (!this.value) return null;
        return this.value.action_params;
      },
      set(value) {
        const payload = this.value || {};
        this.$emit('input', { ...payload, action_params: value });
      },
    },
    actionParams() {
      if (this.value.action_params.length === 0) {
        let actionItem = { id: 'select', name: this.$root.$i18n.locale === 'fr' ? 'Sélectionner' : 'Select' } ;
        return actionItem;
      }
      else if (Array.isArray(this.value.action_params)) {
        let matchingAttribute = this.dropdownValues.find(attr => attr.id === this.value.action_params[0].id) ;
        return matchingAttribute;
      }
      else {
        let matchingAttribute = this.dropdownValues.find(attr => attr.id === this.value.action_params.id) ;
        return matchingAttribute;
      }
    },
    inputType() {
      return this.actionTypes.find(action => action.key === this.action_name)
        .inputType;
    },
    actionInputStyles() {
      return {
        'has-error': this.v.action_params.$dirty && this.v.action_params.$error,
        'is-a-macro': this.isMacro,
      };
    },
    castMessageVmodel: {
      get() {
        if (Array.isArray(this.action_params)) {
          return this.action_params[0];
        }
        return this.action_params;
      },
      set(value) {
        this.action_params = value;
      },
    },
    closeDropdown1() {
      return this.close1;
    },
    closeDropdown2() {
      return this.close2;
    },
  },
  methods: {
    removeAction() {
      this.$emit('removeAction');
    },
    resetAction() {
      this.$emit('resetAction');
    },
    onActionSelect(action) {
      const payload = this.value || {};
      this.$emit('input', { ...payload, action_name: action.key });
      this.resetAction();
    },
    handleClickOutside1(event) {
      // Check that the reference exists before accessing it
      if (this.$refs.dropdownComponent1 && this.$refs.dropdownComponent1.$refs.dropdownElement) {
        const dropdownElement = this.$refs.dropdownComponent1.$refs.dropdownElement;
        if (!dropdownElement.contains(event.target)) {
          this.onCloseDropdown1();
        }
      }
    },
    onCloseDropdown1() {
      this.close1=true;
    },
    onChangeStatus1(value) {
      if (value) {
        this.close1 = false;
      }
    },
    onParamSelect(value) {
      const payload = this.value || {};
      this.$emit('input', { ...payload, action_params: value });
    },
    handleClickOutside2(event) {
      // Check that the reference exists before accessing it
      if (this.$refs.dropdownComponent2 && this.$refs.dropdownComponent2.$refs.dropdownElement) {
        const dropdownElement = this.$refs.dropdownComponent2.$refs.dropdownElement;
        if (!dropdownElement.contains(event.target)) {
          this.onCloseDropdown2();
        }
      }
    },
    onCloseDropdown2() {
      this.close2=true;
    },
    onChangeStatus2(value) {
      if (value) {
        this.close2 = false;
      }
    },
    handleClickOutside3(event) {
      if (this.$refs.myMultiselect) {
        // Access the underlying DOM element
        const dropdownElement = this.$refs.myMultiselect.$el;
        if (!dropdownElement.contains(event.target)) {
          this.onCloseDropdown3();
        }
      }
    },
    onCloseDropdown3() {
      // Access the multiselect component using its ref and call deactivate method
      if (this.$refs.myMultiselect) {
        this.$refs.myMultiselect.deactivate() ;
      }
    },
    handleOpen() {
      bus.$emit('multiselect-open', 'myMultiselect');
      this.$emit('multiOpen');
      bus.$emit('multi-open', this.index);
      this.$emit('multiSelectOpen', this.index);
    },
    onCloseDropdown() {
      this.$emit('multiOpen');
    },
    onMultiOpen(index) {
      this.$emit('multiSelectOpen', this.index);
    }
  },
};
</script>

<style lang="scss" scoped>
.filter {
  background: var(--color-background);
  padding: var(--space-small);
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius-medium);
  margin-bottom: var(--space-small);

  &.is-a-macro {
    margin-bottom: 0;
    background: var(--white);
    padding: var(--space-zero);
    border: unset;
    border-radius: unset;
  }
}

.no-margin-bottom {
  margin-bottom: 0;
}

.filter.has-error {
  background: var(--r-50);
}

.filter-inputs {
  display: flex;
}

.filter-error {
  color: var(--r-500);
  display: block;
  margin: var(--space-smaller) 0;
}

.action__question,
.filter__operator {
  margin-bottom: var(--space-zero);
  margin-right: var(--space-smaller);
}

.action__question {
  max-width: 50%;
}

.action__question.full-width {
  max-width: 100%;
}

.filter__answer--wrap {
  margin-right: var(--space-smaller);
  flex-grow: 1;
  max-width: 50%;

  input {
    margin-bottom: 0;
  }
}
.filter__answer {
  &.answer--text-input {
    margin-bottom: var(--space-zero);
  }
}

.filter__join-operator-wrap {
  position: relative;
  z-index: var(--z-index-twenty);
  margin: var(--space-zero);
}

.filter__join-operator {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: var(--space-one) var(--space-zero);

  .operator__line {
    position: absolute;
    width: 100%;
    border-bottom: 1px solid var(--color-border);
  }

  .operator__select {
    position: relative;
    width: auto;
    margin-bottom: var(--space-zero) !important;
  }
}

::v-deep {
  .multiselect {
    margin-bottom: var(--space-zero);
  }
  .multiselect .multiselect__tag {
    margin-top: 0.25rem ;
    padding: 0.369rem 1.5rem 0.3rem 0.625rem;
  }
  .multiselect .multiselect__tag-icon {
    line-height: 22px !important ;
    width: 14px !important;
  }
  .multiselect__placeholder {
    font-family: "Inter" !important;
    font-style: normal !important;
    font-weight: 500 !important;
    color: #1f2d3d !important;
    text-rendering: optimizeLegibility !important;
  }
}
.action-message {
  margin: var(--space-small) var(--space-zero) var(--space-zero);
}
// Prosemirror does not have a native way of hiding the menu bar, hence
::v-deep .ProseMirror-menubar {
  display: none;
}

.disabled-multiselect {
  pointer-events: none;
  opacity: 0.5;
}
</style>
